import { map } from "rxjs";
import { format } from "date-fns";
import { toSignal } from "@angular/core/rxjs-interop";
import { Injectable } from "@angular/core";

import { DateFormats, GetPagedBody, HttpService, HttpServiceBaseCRUD } from "src/app/core";

@Injectable({
  providedIn: "root",
})
export class BlockDaysService extends HttpService implements HttpServiceBaseCRUD {
  protected override get baseUrl(): string {
    return "blockdays/";
  }

  currentDates = toSignal(this.getAll().pipe(map((dates) => dates.map((each) => format(each.date, DateFormats.ISO)))), {
    initialValue: [],
  });

  add(body: any) {
    return this.post<boolean>({ APIName: "add", body, showAlert: true });
  }

  update(body: any) {
    return this.put<boolean>({ APIName: "update", body, showAlert: true });
  }

  remove(id: string) {
    return this.delete<boolean>({ APIName: `deletesoft/${id}`, showAlert: true });
  }

  getById(id: string) {
    return this.get<any>({ APIName: `get/${id}` });
  }

  getPaged(body: GetPagedBody<any>) {
    return this.getPagedRequest<any[]>({ APIName: "getpaged", body });
  }

  getAll() {
    return this.get<{ id: number; date: string }[]>({ APIName: "getall" });
  }

  removeList(ids: number[]) {
    return this.post<boolean>({ APIName: `deletelist`, body: { ids }, showAlert: true });
  }
}
